// extracted by mini-css-extract-plugin
export default {"items":"inl_ite_4OXZZ","item":"inl_ite_2ay-H"};